import styled, { rem } from 'theme';

export const Wrapper = styled('div')`
  position: relative;
  width: 100%;
  max-width: ${rem(1200)};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;
